import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiKeyApis } from "../utils/apis";
import { createAxiosInstanceUser } from "../utils/request";

export const createApiKey = createAsyncThunk(
  "createApiKey",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        apiKeyApis.createApiKey,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getAllApiKeys = createAsyncThunk(
  "getAllApiKeys",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(apiKeyApis.listApiKeys);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateApiKeyStatus = createAsyncThunk(
  "updateApiKeyStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        apiKeyApis.updateApiKeyStatus,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
